import { IClientStore } from './index'

export default {
  by: 0,
  clients: [],
  direction: 'up',
  filter: '',
  isLoading: false,
  maxPage: 1,
  page: 1,
  pagination: 10,
} as IClientStore
